// extracted by css-extract-rspack-plugin
export default {"error":"error-stebXn text-body-md"};